import React, { useState, useEffect } from "react";
import {
  PageHeader,
  Form,
  Input,
  Image,
  Divider,
  Tabs,
  Button,
  Popconfirm,
  Table,
  Skeleton,
  message,
} from "antd";
import { request } from "../../../utils/fetch";
import { render } from "less";
const LaborDetail = (props) => {
  const params = props.match.params;
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [bjsList, setBjsList] = useState([]);
  const [bqjsList, setBqjsList] = useState([]);
  const [hxjsList, setHxjsList] = useState([]);
  useEffect(() => {
    getDetail();
  }, []);
  // 获取详情数据
  const getDetail = async () => {
    setLoading(true);
    try {
      const res = await request.get("/platform/labourAudit/getDetail", {
        auditNo: params.id,
      });
      setBjsList(res.bjsList || []);
      setBqjsList(res.bqjsList || []);
      setHxjsList(res.hxjsList || []);
      form.setFieldsValue({
        ...res,
        effectiveTime: res.beginDate + " 至 " + res.endDate,
      });
    } catch (error) {
      message.error(error.message);
    } finally {
      setLoading(false);
    }
  };
  // 导出
  const exportData = () => {
    request.downloadTemplate("/platform/labourAudit/exportDetail", {
      auditNo: params.id,
    });
  };
  // 切换tab
  const onChange = (key) => {
    console.log(key);
  };

  const tableColumns = [
    {
      title: "达标日期",
      dataIndex: "standardDate",
      key: "standardDate",
      align: "center",
      width: 120,
    },
    {
      title: "被推荐骑手",
      dataIndex: "name",
      key: "name",
      align: "center",
      width: 120,
    },
    {
      title: "骑手ID",
      dataIndex: "elePointId",
      key: "elePointId",
      align: "center",
      width: 120,
    },
    {
      title: "复入职天数",
      dataIndex: "againDay",
      key: "againDay",
      align: "center",
      width: 100,
    },
    {
      title: "入职日期",
      dataIndex: "entryDate",
      key: "entryDate",
      align: "center",
      width: 120,
    },
    {
      title: "入职站点",
      dataIndex: "elePointName",
      key: "elePointName",
      align: "center",
      width: 180,
    },
    {
      title: "首单日",
      dataIndex: "firstOrderDate",
      key: "firstOrderDate",
      align: "center",
      width: 120,
    },
    {
      title: "结算模式",
      align: "center",
      width: 100,
      render: (row) => `${row.number}/${row.totalNumber}` || "-",
    },
    {
      title: "考核阶段",
      align: "center",
      width: 200,
      render: (row) => `${row.assessStartDate}至${row.assessEndDate}` || "-",
    },
    {
      title: "有效完成单",
      dataIndex: "validOrderCount",
      key: "validOrderCount",
      align: "center",
      width: 120,
    },
    {
      title: "有效出勤天",
      dataIndex: "workDay",
      key: "workDay",
      align: "center",
      width: 120,
    },
    {
      title: "兼职单量",
      align: "center",
      width: 120,
      render: (row) => (row.partOrderCount > 0 ? "已剔除" : row.partOrderCount),
    },
    {
      title: "最新跑单日",
      dataIndex: "lastOrderDate",
      key: "lastOrderDate",
      align: "center",
      width: 120,
    },
    {
      title: "N天没跑单",
      dataIndex: "noOrderDay",
      key: "noOrderDay",
      align: "center",
      width: 120,
    },
    {
      title: "骑手在职状态",
      dataIndex: "jobStatusName",
      key: "jobStatusName",
      align: "center",
      width: 120,
    },
    {
      title: "骑手离职日期",
      dataIndex: "leaveDate",
      key: "leaveDate",
      align: "center",
      width: 120,
    },
    {
      title: "应结算金额",
      dataIndex: "settlementAmount",
      key: "settlementAmount",
      align: "center",
      width: 120,
    },
    {
      title: "费用提审日期",
      dataIndex: "auditDate",
      key: "auditDate",
      align: "center",
      width: 120,
    },
    {
      title: "最终结算金额",
      dataIndex: "auditRealSettlementAmount",
      key: "auditRealSettlementAmount",
      align: "center",
      width: 120,
    },
    {
      title: "备注",
      dataIndex: "settlementRemark",
      key: "settlementRemark",
      align: "center",
      width: 120,
    },
  ];

  return (
    <div>
      <PageHeader title="查看" onBack={() => props.history.goBack()} />
      <Divider size="middle" />
      <Form
        form={form}
        layout="inline"
        style={{
          rowGap: 25,
          columnGap: 20,
        }}
      >
        <Form.Item label="创建时间" name="createTime">
          <Input disabled />
        </Form.Item>
        <Form.Item label="项目" name="projectName">
          <Input disabled />
        </Form.Item>
        <Form.Item label="城市" name="cityName">
          <Input disabled />
        </Form.Item>
        <Form.Item label="劳务公司" name="labourName">
          <Input disabled />
        </Form.Item>
        <Form.Item label="结算类型" name="typeName">
          <Input disabled />
        </Form.Item>
        <Form.Item
          label="生效时间"
          name="effectiveTime"
          style={{ width: "300px" }}
        >
          <Input disabled />
        </Form.Item>
        <Form.Item label="费用说明" name="remark" style={{ width: "100%" }}>
          <Input.TextArea disabled rows={3} />
        </Form.Item>
        <Form.Item>
          <Button type="primary" onClick={exportData}>
            导出
          </Button>
        </Form.Item>
      </Form>

      <Tabs
        defaultActiveKey="1"
        onChange={onChange}
        style={{ background: "#fff", padding: 20 }}
      >
        <Tabs.TabPane tab="已达标(本期结算)" key="1">
          <Table
            columns={tableColumns}
            dataSource={bqjsList}
            bordered
            size="middle"
            scroll={{ x: "max-content" }}
            pagination={false}
            rowKey={(record) => record.id}
          />
        </Tabs.TabPane>
        <Tabs.TabPane tab="已达标(不结算)" key="2">
          <Table
            columns={tableColumns}
            dataSource={bjsList}
            bordered
            size="middle"
            scroll={{ x: "max-content" }}
            pagination={false}
            rowKey={(record) => record.id}
          />
        </Tabs.TabPane>
        <Tabs.TabPane tab="已达标(后续结算)" key="3">
          <Table
            columns={tableColumns}
            dataSource={hxjsList}
            bordered
            size="middle"
            scroll={{ x: "max-content" }}
            pagination={false}
            rowKey={(record) => record.id}
          />
        </Tabs.TabPane>
      </Tabs>
    </div>
  );
};

export default LaborDetail;
